import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/constants";

export default function FaqAccordion({ items = FAQS, testId = "faq-accordion" }) {
  return (
    <Accordion type="single" collapsible className="w-full space-y-3" data-testid={testId}>
      {items.map((it, idx) => (
        <AccordionItem
          key={idx}
          value={`item-${idx}`}
          data-testid={`faq-item-${idx}`}
          className="border border-slate-100 rounded-2xl bg-white px-6 shadow-[0_4px_20px_rgb(0,0,0,0.02)] data-[state=open]:shadow-[0_12px_30px_rgb(0,0,0,0.06)] transition-shadow"
        >
          <AccordionTrigger className="text-left font-display font-bold text-base sm:text-lg text-slate-900 hover:no-underline py-5">
            {it.q}
          </AccordionTrigger>
          <AccordionContent className="text-slate-600 leading-relaxed pb-5 text-[15px]">
            {it.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
